import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { Observable, Subject } from "rxjs";
import { InitReportComponentForm, ReportComponentFormState, ReportComponentFormStateModel } from "./report-component-form.state";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ReportComponentType } from "@core/data/types/advanced-report";
import { takeUntil } from "rxjs/operators";
import { Snackbar } from "@core/material";
import { NumberValidators } from "@core/utils";

export interface ReportComponentFormDialogData {
    dialogType: ReportComponentType;
    maxPages: number;
    maxColumns: number;
    maxRows: number;
    width?: number;
    height?: number;
    activePage?: number;
}

@Component({
    selector: 'pv-report-component-form-dialog',
    templateUrl: 'report-component-form.dialog.html',
    styleUrls:   ['report-component-form.dialog.scss'],
    preserveWhitespaces: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ReportComponentFormDialog implements OnInit, OnDestroy {

    @Select(ReportComponentFormState)
    state$: Observable<ReportComponentFormStateModel>;

    componentTypeControl: FormControl = new FormControl(null, [Validators.required]);
    pageControl: FormControl = new FormControl(0, [Validators.required]);
    heightControl = new FormControl(null, [Validators.required, Validators.min(1), Validators.max(this._data.maxRows), NumberValidators.integer(9)]);
    widthControl = new FormControl(null, [Validators.required, Validators.min(1), Validators.max(this._data.maxColumns), NumberValidators.integer(9)]);

    pageRange = [...Array(this._data.maxPages + 1).keys()].slice(1)

    formGroup: FormGroup = new FormGroup({
        type: this.componentTypeControl,
        page: this.pageControl,
        height: this.heightControl,
        width: this.widthControl,
    });

    private _destroy$ = new Subject();

    constructor(
        private _dialogRef: MatDialogRef<ReportComponentFormDialogData>,
        @Inject(MAT_DIALOG_DATA) private _data: ReportComponentFormDialogData,
        private _store: Store,
        private _snackbar: Snackbar,
    ) {}

    ngOnInit() {
        this._store.dispatch(new InitReportComponentForm(this._data.dialogType));

        this.state$
        .pipe(takeUntil(this._destroy$))
        .subscribe(state => {
            this.reset(state.type)
        })
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    reset(type: ReportComponentType) {
        this.formGroup.reset({
            type: type,
            page: this._data.activePage || 0,
            height: this._data.height || null,
            width: this._data.width || null,
        })

        this.formGroup.enable()
    }

    attempt() {
        this.formGroup.updateValueAndValidity();
        this.formGroup.markAsDirty();

        if (this.formGroup.valid) {
            this._dialogRef.close({status: true, data: this.formGroup.value});

        } else {
            this._snackbar.formInvalid();
        }
    }

    cancel() {
        this._dialogRef.close({status: false});
    }

}